"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.178 8.547L11.694 3v18l-5.516-5.547H3.793c-.99 0-1.793-.81-1.793-1.81v-3.285c0-1 .802-1.811 1.793-1.81h2.385zM14 17V7c2.075.925 3.5 2.815 3.5 5s-1.424 4.075-3.5 5z" }), "Normal");
//# sourceMappingURL=VolumeNormal.js.map